<template>
  <svg xmlns="http://www.w3.org/2000/svg" :class="className" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M13.25 8.75L10 12.25L6.75 8.75" 
    class="stroke-current" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
  export default {
    name: 'ChevronIcon',
    props: {
      width: {
        type: Number,
        default: 20
      },
      height: {
        type: Number,
        default: 20
      },
      className: {
        type: String,
        default: 'text-icon-normal'
      }
    }
  }
</script>

<style scoped></style>